import React, { useEffect } from 'react'
import ChangePassword from '../../components/user/ChangePassword'
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { getMe } from "../../features/authSlice"

const ChangePass = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { isError } = useSelector((state) => state.auth)

    useEffect(() => {
        dispatch(getMe())
    }, [dispatch])

    if (isError) {
        return navigate("/login")
    }

    return (
        <>
            <title>Auth</title>
            <ChangePassword />
        </>
    )
}

export default ChangePass